// Copyright (c) 2023. Heusala Group Oy <info@heusalagroup.fi>. All rights reserved.

import { explainEnum, isEnum, parseEnum, stringifyEnum } from "../../../../../io/hyperify/core/types/Enum";
import { isUndefined } from "../../../../../io/hyperify/core/types/undefined";
import { explainNot, explainOk, explainOr } from "../../../../../io/hyperify/core/types/explain";

export enum PageImage {
    INDEX = "INDEX",
    PHOTO = "PHOTO",
    PREMIUM_DOMAIN = "PREMIUM_DOMAIN",
    ABOUT = "ABOUT",
    VIRTUALSERVERS = "VIRTUALSERVERS",
    EMAIL = "EMAIL",
    NET = "NET",
    WEBRTC = "WEBRTC",
    WEBHOTELS = "WEBHOTELS",
    DATABASE = "DATABASE",
    DOMAINS = "DOMAINS",
    SHELL = "SHELL",
    CUSTOMER_SERVICE = "CUSTOMER_SERVICE",
    CART = "CART",
}

export function isPageImage (value: unknown) : value is PageImage {
    return isEnum(PageImage, value);
}

export function explainPageImage (value : unknown) : string {
    return explainEnum("PageImage", PageImage, isPageImage, value);
}

export function stringifyPageImage (value : PageImage) : string {
    return stringifyEnum(PageImage, value);
}

export function parsePageImage (value: any) : PageImage | undefined {
    return parseEnum(PageImage, value) as PageImage | undefined;
}

export function isPageImageOrUndefined (value: unknown): value is PageImage | undefined {
    return isUndefined(value) || isPageImage(value);
}

export function explainPageImageOrUndefined (value: unknown): string {
    return isPageImageOrUndefined(value) ? explainOk() : explainNot(explainOr(['PageImage', 'undefined']));
}
